import React from 'react';
import { Outlet } from 'react-router-dom';

export const EmptyRoute: React.FC = () => {
  return (
    <>
      <Outlet />
    </>
  );
};
